<template>
  <div
    class="inputs-divider bg-background-neutral-secondary relative flex items-center justify-evenly rounded-2xl py-3 text-base font-semibold"
  >
    <SearchFormInput
      class="text-static-black w-1/2 px-4"
      :placeholder="$t('main.dates.placeholder.departure.full')"
      :text="formattedDates[0]?.value"
      :suffix="formattedDates[0]?.suffix"
      @click="
        emit('onDateSelect', searchFormCalendar.config.CALENDAR_MODES.SINGLE)
      "
    />
    <div class="flex w-1/2 items-center justify-between px-4">
      <SearchFormInput
        class="w-full"
        :placeholder="$t('main.dates.placeholder.arrival.full')"
        :text="formattedDates[1]?.value"
        :suffix="formattedDates[1]?.suffix"
        @click="
          emit('onDateSelect', searchFormCalendar.config.CALENDAR_MODES.RANGE)
        "
      />
      <ClearDateButton
        v-if="formattedDates.length > 1"
        @onDateClear="emit('onDateClear')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { searchFormCalendar, searchForm } from 'shared';
  import { SearchFormInput } from 'freedom-shared';

  import { ClearDateButton } from '@/widgets/search-calendar';

  const props = defineProps<{
    dates: string[];
    source: string;
  }>();

  const emit = defineEmits<{
    (e: 'onDateSelect', mode: searchFormCalendar.config.CalendarMode): void;
    (e: 'onDateClear'): void;
  }>();

  const formattedDates = computed(() =>
    searchForm.lib.formatSearchDate(props.dates),
  );
</script>

<style scoped>
  .inputs-divider:after {
    @apply bg-background-neutral-tertiary absolute left-1/2 h-1/3 w-0.5 rounded-full opacity-50;
    content: '';
  }
</style>
